import { keyframes } from 'styled-components';

export const transitionTiming = '0.25s ease-in';

export const rotate = keyframes`
 from {
   transform: rotate(0deg);
 }

 to {
   transform: rotate(360deg);
 }
`;

export const scaleX = keyframes`
  from {
    transform: scaleX(0);
  }

  to {
    transform: scaleX(1);
  }
`;
